import { render, staticRenderFns } from "./ManualChapterList.vue?vue&type=template&id=25de86e4&scoped=true"
import script from "./ManualChapterList.vue?vue&type=script&lang=js"
export * from "./ManualChapterList.vue?vue&type=script&lang=js"
import style0 from "./ManualChapterList.vue?vue&type=style&index=0&id=25de86e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25de86e4",
  null
  
)

export default component.exports